export const getStorage = (key: string) => {
    return window.localStorage.getItem(key);
};

export const setStorage = (key: string, value: string | Record<string, unknown>) => {
    if (value && typeof value === 'object') {
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
    }

    window.localStorage.setItem(key, value);
};

export const removeStorage = (key: string) => {
    window.localStorage.removeItem(key);
};
